// styles defined in assets/scss/style.scss

function LoadingSpinner({ white = false }) {
    return (
        <div className='loader-container'>
            <div className={`loader ${white ? 'loader-white' : ''}`} />
        </div>
    );
}

export default LoadingSpinner;
